var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
export var reactFormulaEditorId = 'reactFormulaEditor';
// Unfortunately the type definitions for monaco are old. Once the react formula bar is the only
// formula bar this can be removed.
export var ErrorSeverity;
(function (ErrorSeverity) {
    ErrorSeverity[ErrorSeverity["Info"] = 1] = "Info";
    ErrorSeverity[ErrorSeverity["Warning"] = 4] = "Warning";
    ErrorSeverity[ErrorSeverity["Error"] = 8] = "Error";
})(ErrorSeverity || (ErrorSeverity = {}));
var PowerFxFormulaEditorError = /** @class */ (function (_super) {
    __extends(PowerFxFormulaEditorError, _super);
    function PowerFxFormulaEditorError(message) {
        var _this = _super.call(this, message) || this;
        _this.name = 'PowerFxFormulaEditorError';
        return _this;
    }
    return PowerFxFormulaEditorError;
}(Error));
export { PowerFxFormulaEditorError };
export var CommandName;
(function (CommandName) {
    CommandName["CodeActionApplied"] = "codeActionApplied";
})(CommandName || (CommandName = {}));
//# sourceMappingURL=FormulaEditor.types.js.map